export const LandingTrans = {
  english: {
    yoga: "YOGA",
    studio: "STUDIO",
    description: "Yoga doesn't take time, it gives time.",

    once: `Once up on a mat Studio`,
    // uponamat: `Studio`,
    learnMore: "Learn More",
    hiFriends: "🌿 Hi, friends!",
    myNameIs: `My name is Anya. As a former athlete whose body was damaged by improper training, I know what it’s like to live with constant pain. At 16, doctors told me I had "a spine like a grandmother." And at 23, after just a few months of yoga, I completed a 20-kilometer hike — and my life began.`,
    yogaHelped: `Yoga gave me a second chance at my dreams. To travel the world, hike with a backpack, and be free from physical limitations. Almost by accident, my gratitude for this practice and my teachers turned into something I now pass on to others.`,
    iBelieve: `The method I teach is based on knowledge of biomechanics and anatomy, respect for the body’s capabilities, and awareness in every movement. Now I know how bodies break — and how they heal. My mission is to help as many people as possible make yoga part of their lives and, as the hippies said, "die young as late as possible." :)`,
    whatIsThisPractice: "What is this practice?",
    practiceDescription: `This is a dynamic Hatha yoga practice where we work not only with the body but also with the state of the mind. If you're unfamiliar with the term, the simplest explanation is that Hatha is the foundation of all physical yoga — all other styles came from it and reflect the vision of individual people. As my teacher says: "Any yoga style limits it, not enhances it — and yoga doesn’t deserve that."`,
    duration: "Duration",
    notScary: "1.5 hours. Don’t let that scare you.",
    warmup: "Warm-up in the style of Vinyasa yoga",
    mainBlock: "Main block with strength, flexibility, coordination poses",
    shavasana: "Recovery and deep guided Shavasana",
    whoItFits: "Who is it for?",
    newbies: "Beginners",
    regardless: "regardless of physical condition or level. If you can at least even 50% of the practice — you will grow. Want to discuss individual conditions, limitations, or whether group classes are right for you? Call us:",
    pros: "Experienced practitioners",
    forWhom: ", for whom yoga isn’t confined to a strict school or style. Those open to new experiences, who value a scientific approach over an esoteric one. Those willing to work on where they’re weaker, not just where they excel.",
    formats: "Practice Formats",
    liveLessons: "Live Classes",
    liveLessonsDescription: "Living in central Israel? Come to our cozy rooftop studio in Ramat Gan.",
    liveLessonsExtra: "Immerse yourself in a live atmosphere and attentive support from the instructor. Classes every Sunday, Tuesday, and Thursday. Prices range from 25₪ to 70₪ per class depending on subscription.",
    liveLessonsButton: "Book a Trial",
    library: "Library",
    libraryDescription: "An open library of free recordings for self-practice.",
    libraryExtra: "Practice anytime, choose by level, duration, and effect.",
    libraryButton: "Explore",
    club: "Online Club",
    clubDescription: "Need support on your yoga journey? Want to deepen your practice? Join from anywhere in the world!",
    clubExtra: "Each week: a live class + unique recorded practice. Private support chat and sweet bonuses. Monthly subscription – 100₪.",
    clubButton: "Learn More",
    park: "Park Leumi",
    parkDescription: "Gentle lakeside yoga + coffee and good company. We meet every Friday at 10:00.",
    parkExtra: "Practice, relax, and recharge for the whole weekend. Participation fee – 50₪.",
    parkButton: "Join In",
    reviews: "Reviews",
    prices: "Prices",
    trial: "Trial Session",
    one: "One-Time Visit",
    four: "Once Upon a Mat",
    eight: "Twice Upon a Mat",
    limitless: "Always on the Mat",
    clubDes: "Monthly Subscription",
    trialDes: "First studio session",
    oneDes: "One-time studio session",
    fourDes: "4-session monthly pass",
    eightDes: "8-session monthly pass",
    limitlessDes: "Unlimited monthly studio pass",
    contacts: "Contacts",
    yogaStudio: `Yoga Studio "Once Upon a Mat"`,
    address: "Ramat Gan, Hibat Zion, 41",
    leaveRequest: "Leave a Request",
    yourName: "Your Name",
    yourPhone: "Phone (WhatsApp) or Telegram",
    commentOrQuestion: "Comment or Question",
    sending: "Sending",
    send: "Send",
  },
  russian: {
    yoga: "ЙОГА",
    studio: "СТУДИЯ",
    description: "Йога на русском языке в Израиле и онлайн.",
    once: "Однажды",
    uponamat: "на коврике",
    learnMore: "Узнать больше",
    hiFriends: "🌿 Привет, друзья!",
    myNameIs: `Меня зовут Аня. Как бывший травмированный спортсмен, я знаю, какого это жить с постоянной болью.`,
    yogaHelped: `Йога дала мне второй шанс на мечты - путешествовать по миру, ходить в походы под рюкзаком и быть свободной от телесных ограничений. Почти случайно моя благодарность к этой практике и моим учителям переткла в то, что теперь я передаю эти знания дальше.`,
    iBelieve: `Теперь я знаю, как тела ломаются и как собираются. А моя миссия - сделать так, чтобы как можно больше людей сделали йогу частью своей жизни и, как говорили хиппи, - ״умерли молодыми как можно позже״ :)`,
    whatIsThisPractice: "Что это за практика?",
    practiceDescription: `Это динамичная практика Хатха йоги, в которой мы работаем не только с телом, но и с состоянием ума. Если этот термин вам не знаком, то самое просто объяснение это, что Хатха - вся физическая йога, а все остальные стили вышли из неё и являются видением одного человека. Как говорит мой учитель: "Любой стиль йоги ограничивает её, а не дополняет, и она этого не заслуживает".`,
    duration: "Продолжительность",
    notScary: "1,5 часа. Пусть это вас не пугает.",
    warmup: "Разминка в стиле виньяса йоги",
    mainBlock: "Основная часть с силовыми, гибкостными и координационными асанами",
    shavasana: "Восстановление и глубокая шавасана с сопровождением",
    whoItFits: "Кому она подходит?",
    newbies: "Новичкам",
    regardless: "вне зависимости от физического состояния и уровня. Если вы можете выполнить хотя бы 50% практики, вы будете расти. Если вы хотите обсудить индивидуальные особенности, ограничения и узнать, насколько вам подходит групповая практика, не стесняйтесь звонить: ",
    pros: "Продвинутым практикам",
    forWhom: ", для которых йога не ограничивается строгой школой или стилем. Тем, кто открыт к новому опыту, ценит научный подход, а не эзотерический. Кто готов работать над тем, где отстаёт, а не только над тем, в чём уже хорош.",
    formats: "Форматы занятий",
    liveLessons: "Очные занятия",
    liveLessonsDescription: "Живёте в центре Израиля? Приходите в нашу уютную студию на крыше в Рамат-Гане.",
    liveLessonsExtra: "Погружение в живую атмосферу и внимательная поддержка преподавателя. Занятия каждое воскресенье, вторник и четверг. Стоимость от 25₪ до 70₪ за занятие в зависимости от абонимента.",
    liveLessonsButton: "Расписание и запись",
    library: "Библиотека",
    libraryDescription: "Открытая библиотека бесплатных записей для самостоятельной практики.",
    libraryExtra: "Практикуйте в удобное для вас время, выбирайте практику по уровню, времени и типу воздействия.",
    libraryButton: "Открыть",
    club: "Онлайн клуб",
    clubDescription: "Нужна поддержка на пути освоения йоги? Не хвататет развития в практике? Подключайтесь из любой точки мира!",
    clubExtra: "Каждую неделю встречаемся на практику онлайн + уникальная пратика в записи. Закрытый чат поддержки и приятные бонусы. Подписка на месяц - 100₪.",
    clubButton: "Узнать больше",
    park: "Парк Яркон",
    parkDescription: "Мягкая практика йоги у озера + кофе и копмания. Встречаемся каждую пятницу в 10:00.",
    parkExtra: "Практикуем, отдыхаем и заряжаемся на все выходные. Стоимость участия - 50₪.",
    parkButton: "Присоединиться",
    reviews: "Отзывы",
    prices: "Цены",
    trial: "Пробное занятие",
    one: "Разовое посещение",
    four: "Однажды на коврике",
    eight: "Дважды на коврике",
    limitless: "Постоянно на коврике",
    clubDes: "Месячная подписка",
    trialDes: "Первое занятие в студии",
    oneDes: "Разовое занятие в студии",
    fourDes: "Абонемент на 4 занятия в студии в течение месяца",
    eightDes: "Абонемент на 8 занятий в студии в течение месяца",
    limitlessDes: "Безлимитное посещение студии в течение месяца",
    contacts: "Контакты",
    yogaStudio: `Студия йоги "Однажды на коврике"`,
    address: "Рамат-Ган, Хибат Цион, 41",
    leaveRequest: "Оставить заявку",
    yourName: "Ваше имя",
    yourPhone: "Телефон (WhatsApp) или Telegram",
    commentOrQuestion: "Комментарий или вопрос",
    sending: "Отправялется",
    send: "Отправить",
  },
};

export const OnlineClubTrans = {
  english: {
    yoga: "YOGA",
    studio: "STUDIO",
    description: "Yoga doesn't take time, it gives time.",

    once: `Once up on a mat Studio`,
    // uponamat: `Studio`,
    learnMore: "Learn More",
    hiFriends: "🌿 Hi, friends!",
    myNameIs: `My name is Anya. As a former athlete whose body was damaged by improper training, I know what it’s like to live with constant pain. At 16, doctors told me I had "a spine like a grandmother." And at 23, after just a few months of yoga, I completed a 20-kilometer hike — and my life began.`,
    yogaHelped: `Yoga gave me a second chance at my dreams. To travel the world, hike with a backpack, and be free from physical limitations. Almost by accident, my gratitude for this practice and my teachers turned into something I now pass on to others.`,
    iBelieve: `The method I teach is based on knowledge of biomechanics and anatomy, respect for the body’s capabilities, and awareness in every movement. Now I know how bodies break — and how they heal. My mission is to help as many people as possible make yoga part of their lives and, as the hippies said, "die young as late as possible." :)`,
    whatIsThisPractice: "What is this practice?",
    practiceDescription: `This is a dynamic Hatha yoga practice where we work not only with the body but also with the state of the mind. If you're unfamiliar with the term, the simplest explanation is that Hatha is the foundation of all physical yoga — all other styles came from it and reflect the vision of individual people. As my teacher says: "Any yoga style limits it, not enhances it — and yoga doesn’t deserve that."`,
    duration: "Duration",
    notScary: "1.5 hours. Don’t let that scare you.",
    warmup: "Warm-up in the style of Vinyasa yoga",
    mainBlock: "Main block with strength, flexibility, coordination poses",
    shavasana: "Recovery and deep guided Shavasana",
    whoItFits: "Who is it for?",
    newbies: "Beginners",
    regardless: "regardless of physical condition or level. If you can at least even 50% of the practice — you will grow. Want to discuss individual conditions, limitations, or whether group classes are right for you? Call us:",
    pros: "Experienced practitioners",
    forWhom: ", for whom yoga isn’t confined to a strict school or style. Those open to new experiences, who value a scientific approach over an esoteric one. Those willing to work on where they’re weaker, not just where they excel.",
    formats: "What's included in the subscription?",
    formatsDescription: "Each week you receive:",
    liveLessons: "Zoom Practice",
    liveLessonsDescription: "Need support on your yoga journey? Join from anywhere in the world!",
    liveLessonsExtra: "Every week we meet for an online session with cameras on so the instructor can address each participant, help build a safe and effective practice, and fine-tune your asanas.",
    liveLessonsButton: "Watch a Demo Class",
    library: "Library",
    libraryDescription: "Choose practices by level, duration, and focus.",
    libraryExtra: "On-demand sessions from 15 to 90 minutes: strength-building, restorative practices, and tutorials. Practice at your convenience. New video every week.",
    libraryButton: "Open a Sample",
    constructor: "Practice Builder",
    constructorDescription: "Want to focus on splits, arm balances, or spinal health? Build a practice tailored to you!",
    constructorExtra: "Our trained algorithm crafts a sequence that’s both safe and effective. You select intensity, duration, and focus!",
    constructorButton: "How It Works?",
    chat: "Support Chat",
    chatDescription: "Have questions or want to share your progress?",
    chatExtra: "A private support chat for studio clients. We discuss yoga nuances, health, and lifestyle.",
    chatButton: "Join the Chat",
    reviews: "Reviews",
    prices: "Prices",
    trial: "Trial Class",
    one: "Single Visit",
    four: "Once on the Mat",
    eight: "Twice on the Mat",
    limitless: "Always on the Mat",
    clubDes: "Monthly Subscription",
    trialDes: "First class at the studio",
    oneDes: "Single studio class",
    fourDes: "4-class studio pass (valid one month)",
    eightDes: "8-class studio pass (valid one month)",
    limitlessDes: "Unlimited studio access (one month)",
    contacts: "Contacts",
    yogaStudio: `Once Upon a Mat Yoga Studio`,
    address: "41 Hibat Tziyon St., Ramat Gan",
    leaveRequest: "Leave a Request",
    yourName: "Your Name",
    yourPhone: "Phone (WhatsApp or Telegram)",
    commentOrQuestion: "Comment or Question",
    sending: "Sending",
    send: "Send"
  },
  russian: {
    yoga: "ЙОГА",
    studio: "СТУДИЯ",
    description: "Занимайтесь из любой точки мира, в своём ритме.",
    once: "Однажды",
    uponamat: "на коврике",
    onlineClub: "Онлайн клуб",
    learnMore: "Узнать больше",

    aboutClub: "О клубе",
    aboutClubDescription: `Этот проект возник случайно. С помощью блога в инстаграм я хотела привлечь учеников на живые занятия в Израиле. Они пришли, 2,5% подписчиков. Остальные 97,5% оказались русскоязычными людьми со всего мира, спрашивающими об онлайн уроках. Так идея "когда-нибудь выйти в онлайн" стала целью на ближайший месяц. Спасибо вам за этот пинок ❤️`,
    value: "Ценности",
    valueDescription: "Править вас в живую возможности у меня не будет, поэтому включенная камера на онлайн занятиях обязательна. Я верю, что руки - это последний ресурс преподавателя йоги. Учитель должен уметь объяснить всё, даже не показывая на себе, - инструкциями, голосом, вглядом. По крайней мере к этому я стремлюсь, и ваша безопасность для меня на первом месте. На слеующем - эффективность практики.",
    whatIsThisPractice: "Что это за практика?",
    practiceDescription: `Это динамичная практика Хатха йоги, в которой мы работаем не только с телом, но и с состоянием ума. Если этот термин вам не знаком, то самое просто объяснение это, что Хатха - вся физическая йога, а все остальные стили вышли из неё и являются видением одного человека. Как говорит мой учитель: "Любой стиль йоги ограничивает её, а не дополняет, и она этого не заслуживает".`,
    duration: "Продолжительность",
    notScary: "1,5 часа. Пусть это вас не пугает.",
    warmup: "Разминка в стиле виньяса йоги",
    mainBlock: "Основная часть с силовыми, гибкостными и координационными асанами",
    shavasana: "Восстановление и глубокая шавасана с сопровождением",
    beginners: "Новички",
    pros: "Профи",
    whoItFits: "Кому подойдёт онлайн клуб?",
    newbies: "Новичкам",
    regardless: "Вне зависимости от физического состояния и уровня. Если вы цените научный подход, а не эзотерический. Готовы трудиться и преодалевать себя, вам понравится. Если вы хотите обсудить индивидуальные особенности, ограничения и узнать, насколько вам подходит групповая практика, не стесняйтесь звонить: +972 055 91 69",
    pros: "Продвинутым практикам",
    forWhom: "Для которых йога не ограничивается строгой школой или стилем. Тем, кто открыт к новому опыту и ценит научный подход. Кто готов работать над тем, где отстаёт, а не только над тем, в чём уже хорош.",
    formats: "Что входит в подписку?",
    formatsDescrition: "Каждую неделю вы получаете:",
    liveLessons: "Практика в Zoom",
    liveLessonsDescription: "Нужна поддержка на пути освоения йоги? Подключайтесь из любой точки мира!",
    liveLessonsExtra: "Каждую неделю мы встречаемся на онлайн практике со включенными камерами, где у преподавателя будет возможность обратиться к занимающемуся и помочь выстроить безопасную и эффективную практику и отстроить асаны.",
    liveLessonsButton: "Посмотреть демо занятие",
    library: "Библиотека",
    libraryDescription: "Выбирайте практику по уровню, длительности и типу воздействия.",
    libraryExtra: "Практики в записи длительностью от 15 до 90 минут. Силовые, восстанавливающие практики, а так же обучающие туториалы. Практикуйте в удобное для вас время. Новое видео каждую неделю.",
    libraryButton: "Открыть пример",
    constructor: "Конструктор",
    constructorDescription: "Хочешь сделать упор на шпагаты, балансы на руках или здоровье позвоночника? Составь практику под себя!",
    constructorExtra: "С помощью обученного алгоритма ты сможешь создать практику, сохранив безопасность и эффективность последовательности. Ты сам выберешь степень нагрузки, длительность и акцент занятия!",
    constructorButton: "Как это работает?",
    chat: "Чат поддержки",
    chatDescription: "Появились вопросы или хочется поделиться результатом?",
    chatExtra: "Закрытый чат поддержки для клиентов студии. Обсудим тонкости йоги, здоровье и образ жизни",
    chatButton: "Присоединиться к отрытому чату",
    reviews: "Отзывы",
    prices: "Цены",
    trial: "Пробное занятие",
    one: "Разовое посещение",
    four: "Однажды на коврике",
    eight: "Дважды на коврике",
    limitless: "Постоянно на коврике",
    clubDes: "Месячная подписка",
    trialDes: "Первое занятие в студии",
    oneDes: "Разовое занятие в студии",
    fourDes: "Абонемент на 4 занятия в студии в течение месяца",
    eightDes: "Абонемент на 8 занятий в студии в течение месяца",
    limitlessDes: "Безлимитное посещение студии в течение месяца",
    contacts: "Контакты",
    yogaStudio: `Студия йоги "Однажды на коврике"`,
    address: "Рамат-Ган, Хибат Цион, 41",
    leaveRequest: "Оставить заявку",
    yourName: "Ваше имя",
    yourPhone: "Телефон (WhatsApp) или Telegram",
    commentOrQuestion: "Комментарий или вопрос",
    sending: "Отправялется",
    send: "Отправить",
    readyToTry: "Готовы попробовать?",
  },
};

export const HeaderTrans = {
  english: {
    onceUp: "ONCE UP",
    onMat: "ON A MAT",
    about: "ABOUT",
    login: "LOG IN",
    logout: "LOG OUT",
    library: "LIBRARY",
    onlineSessions: "ONLINE TRANSLATIONS",
    constructor: "CONSTRUCTOR",
    shop: "GOODIES",
    contact: "CONTACT",
    liveSessions: "IN-PERSON CLASSES",
    blog: "BLOG",
    schedule: "SCHEDULE",
    studio: "STUDIO",
    aboutUs: "ABOUT US",
    aboutPractice: "ABOUT THE PRACTICE",
    prices: "PRICES",
    reviews: "REVIEWS",
    contacts: "CONTACTS",
    classes: "CLASS FORMATS",
    lives: "LIVES",
  },
  russian: {
    onceUp: "ОДНАЖДЫ",
    onMat: "НА КОВРИКЕ",
    about: "О СТУДИИ",
    login: "ВОЙТИ",
    logout: "ВЫЙТИ",
    library: "БИБЛИОТЕКА",
    onlineSessions: "ОНЛАЙН ТРАНСЛЯЦИИ",
    constructor: "КОНСТРУКТОР",
    shop: "НИШТЯКИ",
    contact: "КОНТАКТЫ",
    liveSessions: "ЖИВЫЕ ЗАНЯТИЯ",
    blog: "БЛОГ",
    schedule: "РАСПИСАНИЕ",
    studio: "СТУДИЯ",
    aboutUs: "О НАС",
    aboutPractice: "О ПРАКТИКЕ",
    prices: "ЦЕНЫ",
    reviews: "ОТЗЫВЫ",
    contacts: "КОНТАКТЫ",
    classes: "ФОРМАТЫ ЗАНЯТИЙ",
    lives: "ТРАНСЛЯЦИИ",

    aboutClub: "О КЛУБЕ",
    whatsIncluded: "ЧТО ВХОДИТ",
    whomFor: "КОМУ ПОДХОДИТ",
  },
};

export const LibraryTrans = {
  english: {
    header: "Library",
    becomeMember: "Become a member to get access to more",
    coffee: "Monthly subsciption at the price of 2 coffee cups :)",
    saved: "Saved Practices",
  },
  russian: {
    header: "Библиотека",
    becomeMember: "Вступай в клуб, чтобы получить доступ ко всем практикам! :)",
    coffee: "(месячная подписка по цене 2-х кофе)",
    saved: "Сохранённые Практики",
  },
};

export const LiveTrans = {
  english: {
    header: "Live Recordings",
    saved: "Saved Practices",
  },
  russian: {
    header: "Записи трансляций",
    saved: "Сохранённые Практики",
  },
};

export const WorkoutTrans = {
  english: {
    any: "Any",
    anyFem: "Any",
    type: "Type",
    level: "Level",
    duration: "Duration",
    beginner: "Beginner",
    experienced: "Experienced",
    advanced: "Advanced",
    recovery: "Recovery",
    progression: "Progression",
    fifteen: "15min",
    thirty: "30min",
    sixty: "60min",
    ninety: "90min",
  },
  russian: {
    any: "Любой",
    anyFem: "Любая",
    type: "Тип",
    level: "Уровень",
    duration: "Длительность",
    beginner: "Начинающий",
    experienced: "Опытный",
    advanced: "Продвинутый",
    recovery: "Восстановление",
    progression: "Развитие",
    fifteen: "15мин",
    thirty: "30мин",
    sixty: "60мин",
    ninety: "90мин",
  },
};

export const OnlineSessionsTrans = {
  english: {
    header: "Schedule",
    liveLessons: "All classes",
    nextLiveSession: "Next online session is on: "
  },
  russian: {
    header: "Расписание",
    liveLessons: "Все занятия:",
    nextLiveSession: "Онлайн практики: "
  },
};

export const ConstructorTrans = {
  english: {
    header: "Create your own workout",
    iWantToWorkOn: "I want to work on:",
    workoutReady: "Your custom practice is ready. Enjoy!",
    previous: "←",
    next: "→",
    tags: "Tags",
    description: "The practice-building algorithm is trained to organize blocks in a physiologically and biomechanically sound sequence, so you can trust it. Blocks will auto-advance. Enjoy! ❤",
  },
  russian: {
    header: "Создай свою тренировку",
    iWantToWorkOn: "Я хочу поработать над:",
    workoutReady: "Твоя тренировка готова",
    previous: "←",
    next: "→",
    tags: "Теги",
    description: "Алгоритм построения практики обучен выстраивать блоки в грамотной последовательности с точки зрения физиологии и биомеханики, так что можешь ему довериться. Блоки будут перелистываться автоматически. Наслаждайся! ❤",
  },
};

export const ButtonsTrans = {
  english: {
    complete: "Completed",
    markAsComplete: "Mark as complete",
    saved: "Saved",
    saveForLater: "Save for later",
    exploreMore: "TO LIBRARY",
    search: "Construct",
    random: "Random",
    buildAgain: "Build Again",
  },
  russian: {
    complete: "Выполнено",
    markAsComplete: "Пометить как выполнено",
    saved: "Сохранено",
    saveForLater: "Сохранить на потом",
    exploreMore: "К БИБЛИОТЕКЕ",
    search: "Построить",
    random: "Случайно",
    buildAgain: "Построить заново",
  },
};

export const TagListTrans = {
  english: {
    balance: "balance",
    twists: "twists",
    splits: "splits",
    backBends: "back bends",
    armBalances: "arm balances",
    core: "core",
    backStrength: "back strength",
    handstands: "handstands",
    legStrength: "legs strength",
    armStrength: "arms strength",
    flexibility: "flexibility",
    breathing: "breathing",
    guidedShavasana: "guided Shavasana",
    hipOpeners: "hip openers",
    lotus: "lotus",
    surya: "surya namaskar",
  },
  russian: {
    balance: "балансы",
    twists: "скрутки",
    splits: "шпагаты",
    backBends: "прогибы",
    armBalances: "балансы на руках",
    core: "пресс",
    backStrength: "мышцы спины",
    handstands: "стойка на руках",
    legStrength: "мышцы ног",
    armStrength: "мышцы рук",
    flexibility: "гибкость",
    breathing: "дыхание",
    guidedShavasana: "шавасана",
    hipOpeners: "раскрытие тазобедренных",
    lotus: "лотос",
    surya: "сурья намаскар",
  },
};

export const FooterTrans = {
  english: {
    about: "About Studio",
    terms: "TERMS OF SERVICE",
    privacy: "PRIVACY POLICY",
    help: "HELP",
    contact: "Contacts",
    faq: "FAQ",
    schedule: "Schedule",
    library: "Library",
    pricing: "Pricing",
    yogaStudio: `Yoga Studio "Once up on a mat".`,
    rights: "© 2025 All rights reserved.",
  },
  russian: {
    about: "О студии",
    terms: "ПОЛЬЗОВАТЕЛЬСКОЕ СОГЛАШЕНИЕ",
    privacy: "ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ",
    help: "ПОМОЩЬ",
    contact: "Контакты",
    faq: "ЧАВО",
    schedule: "Расписание",
    library: "Библиотека",
    pricing: "Абонементы",

    yogaStudio: `Йога студия "Однажды на коврике".`,
    rights: "© 2025 Все права защищены.",
  },
};

export const ScheduleDetailsTrans = {
  english: {
    morningPracticeHeader: "Morning Practices",
    morningPracticeDays: "Every Sunday to Thursday",
    morningPracticeTimes: [
      { time: "7:30 - 8:00", activity: "Pranayama" },
      { time: "8:00 - 9:00", activity: "Yoga" },
    ],
    eveningPracticeHeader: "Evening Practices",
    eveningPracticeDays: "Sunday, Tuesday, Thursday, Saturday",
    eveningPracticeTimes: [
      { time: "20:00 - 21:30", activity: "Yoga" },
    ],
    locationHeader: "Location",
    locationDetails: "Rooftop Yoga Studio, 41 Hibat Tsion St., Ramat Gan",
    registerForClass: "To register for a class, click here:",
    followOnlineLessons: "To join, click here:",
    pranayama: "Pranayama",
    yoga: "Yoga",
    trial: "Trial class",
    dropInClass: "Drop-in class",
    basicPass: "Basic Pass",
    standartPass: "Standart Pass",
    prices: "Price List:",
  },
  russian: {
    morningPracticeHeader: "Утренние",
    morningPracticeDays: "Каждое воскресенье по четверг",
    morningPracticeTimes: [
      { time: "7:30 - 8:00", activity: "Пранаяма" },
      { time: "8:00 - 9:00", activity: "Йога" },
    ],
    eveningPracticeHeader: "Вечерние",
    eveningPracticeDays: "Воскресенье, вторник, четверг, суббота",
    eveningPracticeTimes: [
      { time: "19:30 - 21:00", activity: "Йога" },
    ],
    locationHeader: "Адресс",
    locationDetails: "ул. Хибат Цион 41, Рамат-Ган",
    registerForClass: "Записаться на практику ♥",
    followOnlineLessons: "Чтобы присоединиться, тык сюда:",
    pranayama: "Пранаяма",
    yoga: "Йога",
    trial: "Пробный",
    dropInClass: "Разовый",
    basicPass: "Базовый",
    standartPass: "Стандартный",
    prices: "Цены:",
  },
};

export const ShopTrans = {
  english: {
    header: "Shop",
    description: "Yoga goodies",
    buy: "Buy",
    yogaMat: "Yoga Mat",
    incenseSticks: "Incense Sticks",
    henna: "Henna",
    blocks: "Yoga Blocks (2)",
  },
  russian: {
    header: "Магазин",
    description: "Йога ништяки",
    buy: "Купить",
    yogaMat: "Йога коврик",
    incenseSticks: "Благовония",
    henna: "Натуральная хна (конус)",
    blocks: "Кубики (2)",
  },
};

export const LoginTrans = {
  english: {
    signupHeader: "Sign Up",
    loginHeader: "Login",
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm Password",
    alreadySignedUp: "Already signed up?",
    notRegisteredYet: "Not registered yet?",
    forgotPassword: "Forgot password?",
  },
  russian: {
    signupHeader: "Регистрация",
    loginHeader: "Вход",
    email: "Эл.почта",
    password: "Пароль",
    confirmPassword: "Подтвердить пароль",
    alreadySignedUp: "Уже есть профиль?",
    notRegisteredYet: "Нет профиля?",
    forgotPassword: "Забыли пароль?",
  },
};

export const ChatbotTrans = {
  english: {
    chatbot: "Chatbot",
    header: "Send a message",
    inputPlaceholder: "Type a message...",
    sendButton: "Send",
    defaultResponse: "Hello! How can I assist you today?",
  },
  russian: {
    chatbot: "Чатбот",
    header: "Отправить сообщение",
    inputPlaceholder: "Привет!..",
    defaultResponse: "Hello! How can I assist you today?",
    sendButton: "Пиу",
  },
};

export const ToasterTrans = {
  english: {
    login: "Please log in to try this out!",
    premium: "Please upgrade to try this out!",
    comingSoon: "Coming soon! ♥",
    invalidEmail: "Please enter a valid email.",
    subscribed: "Subscribed successfully!",
    subscribeError: "Subscription failed. Please try again later",
    alreadySubscribed: "You’re already subscribed! :)",
  },
  russian: {
    login: "Войди, чтобы попробовать эту фичу! ♥",
    premium: "Подпишись, чтобы попробовать эту фичу!",
    comingSoon: "Скоро будет! ♥",
    invalidEmail: "Проверьте, корректен ли email",
    subscribed: "Подписка успешна!",
    subscribeError: "Произошла ошибка. Попробуйте еще раз позже",
    alreadySubscribed: "Вы уже подписаны! :)",
  },
};

export const ProfileTrans = {
  english: {
    header: "Profile",
    logout: "Logout",
    profile: "Profile",
    save: "Save",
    community: "Community",
    support: "Support",
    changePlan: "Change",
    classes: "Classes",
    currentPlan: "Current Plan",
    completedClasses: "Classes Completed:",
    savedClasses: "Saved Classes:",
    telegramChat: "Telegram Chat",
    contactSupport: "Contact Support ",
    comingSoon: "Coming Soon",

    memberSince: "Member since:",
    intensity: "Intensity",
    onSightEvents: "On-site Events",
    onlineEvents: "Online Events",
    nothingPlanned: "No upcoming events",
    chat: "Chat",
  },
  russian: {
    header: "Профиль",
    logout: "Выйти",
    profile: "Профиль",
    save: "Cохранить",
    community: "Сообщество",
    support: "Поддержка",
    changePlan: "Отменить подписку",
    classes: "Практики",
    currentPlan: "Текущий план",
    completedClasses: "Завершенные практики: ",
    savedClasses: "Перейти к сохраненным практикам: ",
    telegramChat: "Телеграм чат",
    contactSupport: "Связаться с поддержкой ",
    comingSoon: "Скоро",

    memberSince: "На платформе с:",
    intensity: "Интенсивность",
    onSightEvents: "Живые Мероприятия",
    onlineEvents: "Онлайн Мероприятия",
    nothingPlanned: "Нет запланированных мероприятий",
    chat: "Чат",
    subscribe: "Присоединиться к Онлайн Клубу"

  },
};

export const DaysOfTheWeekTrans = {
  english: {
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday",
  },
  russian: {
    monday: "Понедельник",
    tuesday: "Вторник",
    wednesday: "Среда",
    thursday: "Четверг",
    friday: "Пятница",
    saturday: "Суббота",
    sunday: "Воскресенье",
  },
};

export const BlogTrans = {
  english: {
    header: "Blog",
    newsLetter: "Subscribe to Our Newsletter",
    subscribeSubText: "Get the latest yoga insights and tips straight to your inbox.",
    subscribe: "Subscribe",
    email: "Enter your email",
    all: "All",
    tips: "Tips",
    readMore: "Read More →",
    return: "← Back",
    inspo: "Inspo",
  },
  russian: {
    header: "Блог",
    newsLetter: "Подписаться На Рассылку",
    subscribeSubText: "Получайте свежие советы и инсайты о йоге прямо на свою почту 📩",
    subscribe: "Подписаться",
    email: "Введите свою почту",
    all: "Все",
    tips: "Полезности",
    readMore: "Читать дальше →",
    return: "← Вернуться",
    inspo: "Вдохновение",
  },
};

export const SuccessTrans = {
  english: {
    payment: "Payment Successful!",
    yourSub: "Your subscription is now ",
    active: "active",
    welcome: ". Welcome aboard!",
    firstStep: "First step complete! Now all that’s left is to roll out your mat and leave it in place. It’s now part of your physical and mental space—your gathering point. Return to it whenever you wish, and we’ll be there with you.",
    whatsAvailable: "📦 Here’s what you have access to:",
    liveLessonsDescription: "We meet every week for a live online lesson.",
    liveLessonsExtra: "Please keep your camera on and your display name legible so I can address you personally and help you build a safe, effective asana. The joining link will be pinned in the chat.",
    liveLessonsButton: "Lesson Recordings",
    libraryButton: "Open Library",
    constructorButton: "Go to Practice Builder",
    chatButton: "Join the Chat",
    chatExtra: "A private support chat for club members. We’ll discuss yoga nuances, health, and lifestyle.",
    constructorExtra: "With our trained algorithm you can craft a practice that’s both safe and effective. Choose intensity, duration, and focus for your session!",
    account: "Your Account",
    plan: "Plan",
    started: "Started",
    nextPayment: "Next Payment"
  },
  russian: {
    payment: "Оплата прошла успешно!",
    yourSub: "Ваша подписка теперь",
    active: " активна",
    welcome: ". Добро пожаловать на борт!",
    firstStep: "Первый шаг пройден! Дело за малым - расстелить коврик и не убирать его. Теперь это часть вашего физического и ментального пространства, точка сборки. Возвращайтесь на него так часто, как хочется, а мы составим компанию.",
    whatsAvailable: "📦 Что вам доступно:",
    liveLessonsDescription: "Каждую неделю встречаемся на онлайн уроке.",
    liveLessonsExtra: "На занятии нужна включенная камера и читабельное имя, чтобы я могла обратиться к вам лично и помочь выстроить безопасную и эффективную асану. Ссылка на подключение будет закреплена в чате.",
    liveLessonsButton: "Записи трансляций",
    libraryButton: "Открыть библиотеку",
    constructorButton: "Перейти к конструктору",
    chatButton: "Вступить в чат",
    chatExtra: "Закрытый чат поддержки членов клуба. Обсудим тонкости йоги, здоровье и образ жизни",
    constructorExtra: "С помощью обученного алгоритма ты можешь создать практику, сохранив безопасность и эффективность последовательности. Выбирай степень нагрузки, длительность и акцент занятия!",
    account: "Ваш аккаунт",
    plan: "План",
    started: "Старт",
    nextPayment: "Следующее списание",

    registration: "Подписка на Онлайн Клуб ♡",
    welcome2: "Добро пожаловать!",
    membership: "Подписка в нашем клубе стоит 100₪ (2220₽) в месяц — без скрытых комиссий и дополнительных платежей. Я хотела сделать цену достпуной для всех, но не настолько низкой, чтобы про подписку можно было забыть и не заниматься. Списания происходят автоматически раз в месяц со дня оформления. Вы можете отменить подписку в любой момент в личном кабинете, а так же посмотреть дату следующего списания.",
    dust: "Сдуваем пыль с ковриков и ...",
    interCard: "Карта Израиля и других стран",
    rusCard: "Карта РФ",

  },
};


